import AccountDto from '../models/AccountModel';
import { Configuration } from '../models/ConfigurationModel';
import emptySliceApi from '../store/emptyApiSlice';

interface NavigationParam {
  type: string;
  accountId?: string;
}

interface AdminAccessDto {
  hasAccess: boolean;
  inviteId?: string;
  roleAssignmentId?: string;
}

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getConfiguration: builder.query<Configuration, NavigationParam>({
      query: (param) =>
        `/configuration/${param.type}${
          param.accountId ? `/${param.accountId}` : ''
        }`,
    }),
    getAccountData: builder.query<AccountDto, string>({
      query: (accountId) => `v4/accounts/${accountId}`,
      transformResponse: (data: AccountDto) => ({
        ...data,
        logoUrl: data?.logoUrl
          ? `${data.logoUrl}?v=${new Date().getTime()}`
          : '',
      }),
      providesTags: ['AccountData'],
    }),
    getAdminAccountAccess: builder.query<AdminAccessDto, string>({
      query: (accountId) => ({
        headers: {
          ...{ 'X-SelectedAccountId': accountId },
        },
        url: `/accounts/${accountId}/admins/access`,
      }),
    }),
    deleteUserCookie: builder.mutation<void, void>({
      query: () => ({
        url: '/delete-user-cookie',
        method: 'DELETE',
      }),
    }),
    setLastLoggedin: builder.mutation<void, string>({
      query: (accountId) => ({
        url: `/accounts/${accountId}/lastloggedin`,
        method: 'PUT',
      }),
    }),
  }),
});

export const {
  useGetConfigurationQuery,
  useGetAccountDataQuery,
  useGetAdminAccountAccessQuery,
  useDeleteUserCookieMutation,
  useSetLastLoggedinMutation,
} = apiSlice;
